import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import moment from 'moment';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import CustomPagination from '../../CustomPagination';
import CommonTable from '../../CommonTable/CommonTable';
import TableAction from '../../CommonTable/TableAction';
import StarRating from '../../StarRating';
import Loader from '../../Loader/Loader';

import { updateReviewStatus } from '../../../actions/siteadmin/UserReview/manageReviews';
import { getDynamicTitle } from '../../../helpers/GetDynamicItemName/getDynamicName';
import { dateFormat } from '../../../config';

import cs from '../../../components/commonStyle.css';
import s from './UserReviewsManagement.css';
import messages from '../../../locale/jsonMessages';

class UserReviewsManagement extends React.Component {

	static propTypes = {
		data: PropTypes.array,
		editUser: PropTypes.func,
		title: PropTypes.string.isRequired,
		updateReviewStatus: PropTypes.func.isRequired,
	};

	constructor(props) {
		super(props);
		this.state = {
			value: '',
			currentPage: 1,
			searchList: '',
			typing: false,
			typingTimeout: 0
		}
		this.paginationData = this.paginationData.bind(this);
		this.handleSearchChange = this.handleSearchChange.bind(this);
		this.handleClick = this.handleClick.bind(this);
	}

	paginationData(currentPage) {
		const { refetch } = this.props;
		const { searchList } = this.state;
		let variables = { currentPage, searchList };
		this.setState({ currentPage, searchList });
		refetch(variables);
	}

	handleClick(searchList) {
		const { refetch } = this.props;
		const { currentPage } = this.state;
		let variables = {
			currentPage: 1,
			searchList: searchList
		};
		this.setState({ currentPage: 1, searchList: searchList });
		refetch(variables);
	}

	handleSearchChange = (e) => {
		const self = this;
		if (self.state.typingTimeout) {
			clearTimeout(self.state.typingTimeout);
		}
		self.setState({
			searchList: e.target.value,
			typing: false,
			typingTimeout: setTimeout(function () {
				self.handleClick(self.state.searchList);
			}, 450)
		});
	}

	thead = () => {
		const { formatMessage } = this.props.intl;
		return [
			{ data: formatMessage(messages.listId) },
			{ data: formatMessage(messages.reviewContentLabel) },
			{ data: formatMessage(messages.adminListTitle) },
			{ data: formatMessage(messages.reservationConfirmCode) },
			{ data: formatMessage(messages.CheckInDate) },
			{ data: formatMessage(messages.CheckOutDate) },
			{ data: formatMessage(messages.SenderLabel) },
			{ data: formatMessage(messages.receiverLabel) },
			{ data: formatMessage(messages.ratingReviewLabel) },
			{ data: formatMessage(messages.reviewStatusLabel) },
			{ data: formatMessage(messages.reviewActionLabel) },
		]
	};

	tbody = (props) => {
		const { data, updateReviewStatus, locale, dynamicTitle } = props;
		const { currentPage, searchList } = this.state;

		return data?.reviewsData.map(value => {
			let content, reviewContent, dots, isContent, dynamicListTitle;
			let hostName, guestName, hostProfileId, guestProfileId, title, confirmationCode, checkInDate, checkOutDate;

			content = value.reviewContent;
			reviewContent = content.slice(0, 10);
			dots = '...'
			isContent = false;
			if (content.length > 10) {
				isContent = true;
			} else {
				isContent = false;
			}

			hostName = value.userData && value.userData.firstName;
			guestName = value.authorData && value.authorData.firstName;
			hostProfileId = value.userData && value.userData.profileId;
			guestProfileId = value.authorData && value.authorData.profileId;
			title = value.listData && value.listData.title ? value.listData.title : 'List is missing';
			confirmationCode = value.singleReservationData && value.singleReservationData.confirmationCode ? value.singleReservationData.confirmationCode : '';
			checkInDate = value.singleReservationData && value.singleReservationData.checkIn ? moment(parseInt(value.singleReservationData.checkIn)).format(dateFormat?.usDateFormat) : '';
			checkOutDate = value.singleReservationData && value.singleReservationData.checkOut ? moment(parseInt(value.singleReservationData.checkOut)).format(dateFormat?.usDateFormat) : '';
			dynamicListTitle = getDynamicTitle({ data: dynamicTitle, locale, id: value?.listId });

			return {
				id: value?.id,
				data: [
					{ data: value?.listId },
					{
						data: <div className={cx(cs.displayFlex, cs.alignCenter, cs.spaceBetween)}>
							{reviewContent.concat(dots)}
							<TableAction
								showEdit
								editLink={"/siteadmin/management-reviews/" + value.id}
							/>
						</div>
					},
					{
						data: <div><a href={"/cars/" + value.listId} target="_blank">
							{dynamicListTitle || title}
						</a></div>
					},
					{ data: confirmationCode },
					{ data: checkInDate },
					{ data: checkOutDate },
					{
						data: <div><a href={"/users/show/" + guestProfileId} target="_blank">
							{guestName}
						</a></div>
					},
					{
						data: <div><a href={"/users/show/" + hostProfileId} target="_blank">
							{hostName}
						</a></div>
					},
					{
						data: <StarRating
							value={value.rating}
							name={'review'}
							starCount={5}
						/>
					},
					{ data: !value.isAdminEnable ? <FormattedMessage  {...messages.disabledLabel} /> : <FormattedMessage  {...messages.enabledLabel} /> },
					{
						data: !value.isAdminEnable ? <div><a href="javascript:void(0)" onClick={() => updateReviewStatus(value.id, 'enable', { currentPage, searchList })}>
							<FormattedMessage  {...messages.setToEnable} />
						</a></div> : <div><a href="javascript:void(0)" onClick={() => updateReviewStatus(value.id, 'disable', { currentPage, searchList })}>
							<FormattedMessage  {...messages.setToDisable} />
						</a></div>
					},
				]
			}
		})
	}

	render() {
		const { data, loading } = this.props;
		const { formatMessage } = this.props.intl;
		const { currentPage } = this.state;

		if (loading) {
			return <Loader type={"text"} />
		}
		return (
			<div>
				<CommonTable
					thead={this.thead}
					tbody={() => this.tbody(this.props)}
					title={formatMessage(messages.manageReviews)}
					isSearch
					onSearch={this.handleSearchChange}
				/>
				{
					!loading && data?.reviewsData.length > 0
					&& <div>
						<CustomPagination
							total={data.count}
							currentPage={currentPage}
							defaultCurrent={1}
							defaultPageSize={10}
							change={this.paginationData}
							paginationLabel={formatMessage(messages.reviews)}
						/>
					</div>
				}
			</div>
		);
	}

}

const mapState = (state) => ({
	locale: state?.intl?.locale,
	dynamicTitle: state?.dynamicListTitles?.data?.dynamicListTitle
});

const mapDispatch = {
	updateReviewStatus
};

export default injectIntl(withStyles(cs, s)(connect(mapState, mapDispatch)(UserReviewsManagement)));